import './menu.css';
import dataStore from '../../data/data';
import Editor from '../editor/editor';
import Propagate from '../engine/propagate';
import { useParams,useSearchParams } from 'react-router-dom';
import { useEffect,useState } from 'react';

const SessionMenu = () => {
  const setData = dataStore.setState;
  const [audio, setAudio] = useState('');
  const [audioDevices, setAudioDevices] = useState([]);
  const [camera, setCamera] = useState('');
  const [cameraDevices, setCameraDevices] = useState([]);
  const [generate, setGenerate] = useState(false);
  const [mediaReady, setMediaReady] = useState(false);
  const [sessionLinkCopied, setSessionLinkCopied] = useState(false);
  const [vitruvianId, setVitruvianId] = useState('');

  const [searchParams]=useSearchParams();
  const initiator = searchParams.get('initiator') === 'true';
  
  const {sessionId}=useParams();
  const sessionLink =`${window.location.origin}/mirror-cast/${sessionId}`;

  const sessionLinkCopy = () => {
    navigator.clipboard.writeText(sessionLink);
    setSessionLinkCopied(true);
    setTimeout(()=>setSessionLinkCopied(false),1500);
  };

  useEffect(() => {
    setData((_data)=>({
      ..._data,
      mirror:{
        ..._data.mirror,
        initiator:true
      }
    }));
  },[initiator]);

  useEffect(() => {
    const initMedia = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true,
        });

        const devices = await navigator.mediaDevices.enumerateDevices();

        const audioInputDevices = devices.filter(
          device => device.kind === 'audioinput'
        );

        const videoDevices = devices.filter(
          device => device.kind === 'videoinput'
        );

        setAudioDevices(audioInputDevices);
        setCameraDevices(videoDevices);

        if (audioInputDevices.length > 0) {
          setAudio(audioInputDevices[0].deviceId);
        }

        if (videoDevices.length > 0) {
          setCamera(videoDevices[0].deviceId);
        }

        setMediaReady(true);
      } catch (err) {
        console.error('Media initialization failed:', err);
      }
    };

    initMedia();
  }, []);

  useEffect(() => {
    setData(_data => ({
      ..._data,
      mirror: {
        ..._data.mirror,
        audio: {
          ..._data.mirror.audio,
          device: {
            ..._data.mirror.audio.device,
            id: audio,
          },
        },
        camera,
        sessionId,
        vitruvianId,
      },
    }));
  }, [audio, camera,sessionId, vitruvianId, setData]);
  
  if (!mediaReady) {
    return (
      <div className='menu-container' style={{ color: 'white' }}>
        Initializing media...
      </div>
    );
  }

  const handleGenerate = async () => {
    if (!mediaReady || !sessionId || !vitruvianId) return;
    setGenerate(true);
  };

  return (
    <>
      <div className='menu-container'>
        <div className='menu-selection-wrapper'>
          <div className='menu-section'>

            <div className='menu-title'>Mirror Cast Session</div>

            <div className='menu-row'>
              <label className='menu-label'>Vitruvian ID:</label>
              <input
                className='menu-input'
                value={vitruvianId}
                onChange={(e) => setVitruvianId(e.target.value)}
                placeholder='Enter ID'
              />
            </div>

            {/* Cast */}
            {vitruvianId && (
              <div>
                <div className='menu-row'>
                  <label className='menu-label'>Session Link:</label>
                  <button className='menu-session-copy-button' onClick={sessionLinkCopy}>
                    {sessionLink}
                  </button>
                  {sessionLinkCopied && <span className='menu-session-copy'>✔ Copied!</span>}
                </div>
                {audioDevices.length > 0 && (
                  <div className='menu-camera-select'>
                    <label className='menu-label'>Microphone:</label>
                    <select
                      className='menu-select'
                      value={audio}
                      onChange={(e) => setAudio(e.target.value)}
                    >
                      {audioDevices.map((device, index) => (
                        <option key={device.deviceId} value={device.deviceId}>
                          {device.label || `Microphone ${index + 1}`}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {cameraDevices.length > 0 && (
                  <div className='menu-camera-select'>
                    <label className='menu-label'>Camera:</label>
                    <select
                      className='menu-select'
                      value={camera}
                      onChange={(e) => setCamera(e.target.value)}
                    >
                      {cameraDevices.map((device, index) => (
                        <option key={device.deviceId} value={device.deviceId}>
                          {device.label || `Camera ${index + 1}`}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className='menu-selection-wrapper'>
                  <div className='menu-section'>
                    <button className='menu-button' onClick={handleGenerate}>
                      Join Session
                    </button>
                  </div>
                </div>
              </div>
            )}

            {generate && mediaReady && (
              <div className='menu-propagate-container'>
                <div className='menu-propagate-frame'>
                  <Propagate />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Editor/>
    </>
  );
};

export default SessionMenu;